import { Link, useSearchParams } from "react-router-dom";
import { Nav } from "@/components/Nav";
import { SiteFooter } from "@/components/SiteFooter";
import { FadeUp } from "@/components/FadeUp";
import { SeamDivider } from "@/components/SeamDivider";
import { HomePlateLogo } from "@/components/HomePlateLogo";

export default function WelcomePage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");

  return (
    <div className="min-h-screen bg-brand-paper text-brand-black flex flex-col">
      <Nav />
      <main className="flex-1 flex items-center justify-center px-6 pt-28 pb-16 md:pt-32">
        <div className="max-w-3xl w-full text-center">
          <FadeUp>
            <div
              className="mx-auto w-full max-w-md bg-white border border-brand-black shadow-hard px-8 py-10 md:px-10 md:py-12 relative"
              data-testid="welcome-scoreboard-pedestal"
            >
              <span
                aria-hidden="true"
                className="absolute top-0 inset-x-0 h-[3px] bg-brand-red"
              />
              <div className="flex justify-center">
                <HomePlateLogo size={140} />
              </div>
              <p className="mt-7 font-mono text-[10px] font-bold tracking-[0.28em] text-brand-muted-strong uppercase">
                The Box Score Club
              </p>
            </div>
          </FadeUp>
          <FadeUp delay={120}>
            <p className="mt-10 font-mono text-[11px] font-bold tracking-[0.28em] text-brand-red uppercase">
              Welcome
            </p>
          </FadeUp>
          <FadeUp delay={200}>
            <h1 className="mt-4 font-serif font-black text-display-xl text-brand-black">
              You're in.
            </h1>
          </FadeUp>
          <FadeUp delay={320}>
            <p className="mt-6 text-lg md:text-xl text-brand-muted-strong leading-relaxed">
              First recap lands tomorrow morning.
            </p>
          </FadeUp>
          <FadeUp delay={440}>
            <SeamDivider className="mt-8 max-w-xs" />
            <p className="mt-8 text-sm text-brand-muted">
              Replies go to{" "}
              <a
                href="mailto:recap@theboxscoreclub.com"
                className="text-brand-red underline underline-offset-4 hover:text-brand-red-hover transition-colors"
              >
                recap@theboxscoreclub.com
              </a>
              . We read them.
            </p>
          </FadeUp>
          <FadeUp delay={560}>
            <div className="mt-10">
              <Link
                to="/"
                className="inline-flex items-center gap-2 bg-transparent text-brand-black border border-brand-black px-6 py-3 text-sm font-semibold hover:text-brand-red hover:border-brand-red transition-colors duration-200"
              >
                <span aria-hidden="true">←</span>
                Back home
              </Link>
            </div>
          </FadeUp>
          {sessionId && (
            <p className="mt-12 text-xs text-brand-muted-soft font-mono break-all">
              {sessionId}
            </p>
          )}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
